export class PaymentProcessorModel {
    public Id: string;
    public ImagePath: string;
    public Name: string;
    public WebSite: string;
    public Members: string;
    public Payments: string;
    public Countries: string;
    public Currencies: string;
    public FundsProcessed: string;
}